import { getServerDate } from "../config/dateformatter";

// The capital/profit split is only ever collected for a partial
// "profit + capital" payout, and even then the admin can opt out of it by
// ticking "Make partial payment to everyone" — in which case the backend
// works out each investor's share and the two amounts must not be sent.
export const showsCapitalProfitSplit = (values) =>
  values?.payout_type?.value === "partial" &&
  values?.repayment_type?.value === "profit_capital" &&
  !values?.pay_everyone_partially;

export const buildMudarabahPayload = ({
  values,
  cycle,
  invID,
  beneficiaries,
}) => {
  const payload = {
    investment_product_id: cycle?.investment_id || invID,
    beneficiaries,
    roi_percentage: Number(values?.roi_percentage),
    payout_date: getServerDate(values?.payout_date),
    payout_type: values?.payout_type?.value,
    repayment_type: values?.repayment_type?.value,
    amount_to_disburse: Number(values?.amount_to_disburse),
    installment_type: values?.installment_type,
    narration: values?.narration,
  };

  if (cycle?.id) {
    payload.cycle_id = cycle?.id;
  }

  if (showsCapitalProfitSplit(values)) {
    payload.capital_amount = Number(values?.capital_amount);
    payload.profit_amount = Number(values?.profit_amount);
  }

  return payload;
};
